/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const navbarInit = () => {
  const header = document.querySelector('.header');

  // Handle mobile menu animation on toggler click
  const headerNav = header.querySelector('.header__navigation');
  const toggler = header.querySelector('.header__toggler');
  const HEADER_ACTIVE_CLASS = 'header--active';
  const TOGGLER_ACTIVE_CLASS = 'toggler--active';

  const toggleActive = () => {
    header.classList.toggle(HEADER_ACTIVE_CLASS);
    toggler.classList.toggle(TOGGLER_ACTIVE_CLASS);
  };

  const handleClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      toggleActive();
    }
  };

  // Handle scroll animation for mobile menu
  const HEADER_SCROLL_CLASS = 'header--scroll';
  let ticking: boolean = false;

  const handleScroll = () => {
    header.classList.toggle(HEADER_SCROLL_CLASS, window.scrollY > 0);
  };

  toggler.addEventListener('click', toggleActive);

  headerNav.addEventListener('click', handleClick);

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });

      ticking = true;
    }
  }, { passive: true });
};

export default navbarInit;
